//@flow
import TextComponent from "../../Components/CellComponents/TextComponent";
import TextDataUI from "../../Components/DataUIComponents/TextDataUI";
import { type DataType, type textCellType } from "../index";

const PhoneType = {
  icon: "fa fa-phone",
  cellComponent: TextComponent,
  dataUIComponent: TextDataUI,
  displayName: "Phone",
  sortFunction: sorter,
  filter: null
};

export default PhoneType;

function sorter(first: textCellType, second: textCellType) {
  if (first < second) {
    return 1;
  } else {
    return 0;
  }
}
